import React, { useRef, useState, useEffect } from 'react';
import StudentTemplate from '../../component/StudentTemplate';
import SchoolIcon from '@mui/icons-material/School';
import profile1 from '../../Assets/img/student.jpg';
import Api from "../../component/Api";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Loader from '../../component/Loader';





const Home = () => {

  const [activeRecordsCountSpec, setActiveRecordsCountSpec] = useState(0);
  const [loading, setLoading] = useState(false);
  const [studentdata, setStudentData] = useState(false);
  const [getStudentSwitchStatData, setStudentSwitchStatData] = useState([]);
  const [studentEXdata, setStudentEXData] = useState(false);
  const [studentResultdata, setStudentResultData] = useState([]);

  const [profile, setProfile] = useState(null);
  const [markDetails, setMarkDetails] = useState(null);
  const [activeTab, setActiveTab] = useState('personal');
  const navigate = useNavigate();
  const [activecoTab, setActiveCoTab] = useState(1);
  const [isAccordionOpen, setAccordionOpen] = useState(false);
  const { http } = Api();
  const [deactiveTab, setdeActiveTab] = useState([]);
  const templateRef = useRef();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };

  const handleCoTabClick = (tab, semesterId) => {
    setActiveCoTab(tab);
    fetchstudentExamregData(semesterId);
  };

  const fullYear = (dateString) => {
    const date = new Date(dateString);
    const year = String(date.getFullYear());
    return year;
  };


  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   const day = String(date.getDate()).padStart(2, '0');
  //   const month = String(date.getMonth() + 1).padStart(2, '0');
  //   const year = String(date.getFullYear());
  //   // const year = String(date.getFullYear()).slice(-2);
  //   return `${day}-${month}-${year}`;
  // };


  useEffect(() => {
    // Ensure that initially, all accordions are collapsed
    if (studentEXdata) {
      const defaultExpanded = Object.keys(studentEXdata);
      setdeActiveTab(defaultExpanded); // Expand the first accordion by default
    }
  }, [studentEXdata]);

  const toggleTab = (tab) => {
    setdeActiveTab(tabs => {
      if (tabs.includes(tab)) {
        return tabs.filter(t => t !== tab);
      } else {
        return [...tabs, tab];
      }
    });
  };

  const fetchstudentExamregData = async (semesterId) => {

    const { http } = Api(); // Assuming Api() is defined elsewhere
    try {
      const response = await http.get('/Student/getStudentexamregistration', {
        params: { semester: semesterId },
      });
      setStudentEXData(response.data.examstatus);
//console.log("result",response.data.examstatus)
      // Use the result_data nested inside courses to populate studentResultdata properly
      const resultData = [];
      Object.values(response.data.examstatus).forEach((courses) => {
        courses.forEach((course) => {
          if (course.result_data) {
            resultData.push({ ...course.result_data, course_id: course.course_id });
          }
        });
      });
      setStudentResultData(resultData);
      // console.log("studentResultdata afsal =", resultData);
    } catch (error) {
      if (error.response?.data?.http_status === 401) {
        toast.error('Invalid token');
        setTimeout(() => navigate('/'), 5000);
      } else {
        // toast.error('Exam data not found');
      }
    }

  };

  useEffect(() => {
    const { http } = Api();
    const studentdata = async () => {
      try {
        const response = await http.get('/Student/getStudentprofile');
        setStudentData(response.data.studentdata[0]);
        setStudentSwitchStatData(response.data.studentdata[0].switch_stat);

        setProfile(response.data.studentdata[0].studentphoto.original.base64_image);
        setMarkDetails(response.data.markdetails);
      } catch (error) {
        if (error.response?.data?.http_status === 401) {
          toast.error('Invalid token');
          setTimeout(() => navigate('/'), 5000);
        } else {
          // toast.error('Error fetching Student data');
        }
      }
    };

    studentdata();
    fetchstudentExamregData(1); // Fetch data for the first semester on load
  }, []);


  return (
    <>
      <StudentTemplate>
        <ToastContainer />
        <div className="container-fluid">
          {studentdata ? (
            <div>
              <div className="row">
                <div className="col-xl-4 col-sm-4 col-xxl-3">
                  <div className="card card1">
                    <div class="card-header ">
                      <h4 className="card-title mb-0 mobile">My Profile</h4>
                    </div>
                    <div className="card-body">


                      <div className="social-img-wrap col-st-image-wrap">
                        <div className="social-img col-st-image-prof">
                          <img src={profile} alt="profile" className="prof-img-ht zoom-img" /></div>
                        <div className="edit-icon col-img-rt">
                          {studentdata.status === 'active' ?
                            <svg className="st-act-btn">
                              <use href="../assets/svg/icon-sprite.svg#profile-check"></use>
                            </svg>
                            : null}
                        </div>
                      </div>
                      <div className="social-details">
                        <div className="media-body prof-bak-clr">
                          <h5 className="mb-1 m-b-5">{studentdata.studentname}</h5>

                          <div className="lang"><i class="fa fa-info-circle"></i>
                            <span className="lang-txt">{studentdata.accountid}</span></div>
                          {/* {studentdata.status === 'active' ?

                        <div className="lang"><i class="fa fa-circle st-act-btn" aria-hidden="true"></i>
                          <span className="lang-txt">Active</span></div> :
                        null} */}

                        </div>


                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-8 col-sm-8 col-xxl-9">
                  <div className="card">
                    <div className="card-header ">
                      <h4 className="card-title mb-0 mobile">Basic Details</h4>
                    </div>

                    <div class="card-body p-2">
                      <div className="card-body p-0 activity-scroll-container activity-scroll-bar-container clg-card-ht2 ">

                        <div class="table-responsive">

                          <table class="table table-striped">

                            <tbody className="tab-bor-n">
                              {studentdata.PRN ? (
                                <tr>
                                  <th scope="row">Student ID-PRN</th>
                                  <td>:</td>
                                  <td>{studentdata.PRN}</td>

                                </tr>
                              ) : null}
                              <tr>
                                <th scope="row">Admission Year</th>
                                <td>:</td>
                                <td>{studentdata.admissionyear}</td>

                              </tr>
                              <tr>
                                <th scope="row">APAAR. No:</th>
                                <td>:</td>
                                <td>{studentdata.apaar_no}</td>

                              </tr>

                              <tr>
                                <th scope="row">Gender</th>
                                <td>:</td>
                                <td>{studentdata.student_sex}</td>

                              </tr>
                              <tr>
                                <th scope="row">Age</th>
                                <td>:</td>
                                <td> {studentdata.age ? `${studentdata.age} Yrs` : ''}</td>

                              </tr>
                              <tr>
                                <th scope="row">Date of Birth (DD-MM-YYYY)</th>
                                <td>:</td>
                                <td>{studentdata.student_dob}</td>

                              </tr>

                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <div className="row">
                {/* First Card - General Information */}
                <div className="col-xl-6 col-md-6 col-sm-7">
                  <div className="card">
                    <div className="card-header ">
                      <h4 className='mobile'>General Information</h4>
                    </div>

                    <div className="card-body p-2">
                      {/* Tab Navigation */}
                      <ul className="nav nav-tabs border-tab border-0 mb-0 nav-danger"
                        role="tablist"
                        style={{ display: 'flex', justifyContent: 'space-between', padding: 0, margin: 0 }}>
                        <li className="nav-item" style={{ flex: 1 }}>
                          <button
                            className={`nav-link ${activeTab === 'personal' ? 'active' : ''} nav-border pt-0 txt-danger nav-danger`}
                            onClick={() => handleTabClick('personal')}
                            type="button"
                            style={{ width: '100%', textAlign: 'center' }}>
                            <i className="icofont icofont-man-in-glasses"></i> Personal
                          </button>
                        </li>
                        <li className="nav-item" style={{ flex: 1 }}>
                          <button
                            className={`nav-link ${activeTab === 'communication' ? 'active' : ''} nav-border txt-danger nav-danger`}
                            onClick={() => handleTabClick('communication')}
                            type="button"
                            style={{ width: '100%', textAlign: 'center' }}>
                            <i className="icofont icofont-file-document"></i> Communication
                          </button>
                        </li>
                      </ul>

                      {/* Tab Content with Scrollable Area */}
                      <div className="tab-content tab-bor-n" style={{ padding: "0px" }}>
                        {/* Personal Tab */}
                        <div className={`tab-pane fade ${activeTab === 'personal' ? 'show active' : ''}`} role="tabpanel">
                          <div className="activity-scroll-container activity-scroll-bar-container clg-card-ht3">
                            <div className="table-responsive">
                              <table className="table mb-0 table-striped">
                                <tbody className="tab-bor-n">
                                  <tr>
                                    <th scope="row">Aadhar No:</th>
                                    <td>:</td>
                                    <td>{studentdata.aadhar_no}</td>
                                  </tr>

                                  <tr>
                                    <th scope="row">Religion</th>
                                    <td>:</td>
                                    <td>{studentdata.religion_name}</td>

                                  </tr>
                                  <tr>
                                    <th scope="row">Caste</th>
                                    <td>:</td>
                                    <td>{studentdata.caste_name}</td>

                                  </tr>
                                  {/* <tr>
                                    <th scope="row">Nationality</th>
                                    <th>{studentdata.sdid}</th>

                                  </tr> */}
                                  <tr>
                                    <th scope="row">Name of Guardian</th>
                                    <td>:</td>
                                    <td>{studentdata.student_guardian}</td>

                                  </tr>
                                  {/* <tr>
                                    <th scope="row">Relationship</th>
                                    <th>{studentdata.sdid}</th>

                                  </tr> */}
                                  <tr>
                                    <th scope="row">Annual Income</th>
                                    <td>:</td>
                                    <td>{studentdata.annualincome}/-</td>


                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        {/* Communication Tab */}
                        <div className={`tab-pane fade ${activeTab === 'communication' ? 'show active' : ''}`} role="tabpanel">
                          <div className="activity-scroll-container activity-scroll-bar-container clg-card-ht3">
                            <div className="table-responsive">
                              <table className="table mb-0 table-striped">
                                <tbody>
                                  <tr>
                                    <th scope="row" width="30%">Email</th>
                                    <td>:</td>
                                    <td>{studentdata.student_email}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Phone No.</th>
                                    <td>:</td>
                                    <td>{studentdata.student_mobile_no}</td>

                                  </tr>
                                  <tr>
                                    <th scope="row">House Name</th>
                                    <td>:</td>
                                    <td>{studentdata.student_housename}</td>

                                  </tr>
                                  <tr>
                                    <th scope="row">Street/Area</th>
                                    <td>:</td>
                                    <td>{studentdata.student_place}</td>

                                  </tr>
                                  <tr>
                                    <th scope="row">District/Pincode</th>
                                    <td>:</td>
                                    <td>{studentdata.district_name}-{studentdata.student_pin}</td>

                                  </tr>
                                  <tr>
                                    <th scope="row">State</th>
                                    <td>:</td>
                                    <td>{studentdata.state}</td>

                                  </tr>
                                  <tr>
                                    <th scope="row">District</th>
                                    <td>:</td>
                                    <td>{studentdata.district_name}</td>

                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Second Card - Academic Details */}
                <div className="col-xl-6 col-md-6 col-sm-5">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title mb-0 mobile">Academic Details</h4>
                    </div>
                    <div className="card-body p-2">
                      <div className="activity-scroll-container activity-scroll-bar-container clg-card-ht4">
                        <div className="table-responsive">
                          <table className="table table-striped">
                            <tbody className="tab-bor-n">
                              {getStudentSwitchStatData && (getStudentSwitchStatData === 'college_transfer_only' || getStudentSwitchStatData === 'major_college_change') ? (
                                <>
                                  <tr>
                                    <th width="40%">Admitted College Name</th>
                                    <td>:</td>
                                    <td>{studentdata.college_name}</td>
                                  </tr>

                                  <tr>
                                    <th scope="row">Transferred to</th>
                                    <td>:</td>
                                    <td><b className="transferred-highlight transfer-txt">{studentdata.switched_college_name}</b></td>

                                  </tr>
                                </>
                              ) : (

                                <tr>
                                  <th width="40%">College Name</th>
                                  <td>:</td>
                                  <td>{studentdata.college_name}</td>
                                </tr>

                              )}
                              <tr>
                                <th>Major Course Type</th>
                                <td>:</td>
                                <td>{studentdata.college_course_type}</td>

                              </tr>
                              <tr>
                                <th scope="row">Application No.</th>
                                <td>:</td>
                                <td>{studentdata.student_application_no}</td>

                              </tr>
                              <tr>
                                <th scope="row">Admitted Programme</th>
                                <td>:</td>
                                <td>{studentdata.specialisation_display_name}</td>

                              </tr>
                              {getStudentSwitchStatData && (getStudentSwitchStatData === 'major_change_only' || getStudentSwitchStatData === 'major_college_change') && (

                                <tr>
                                  <th scope="row">Switched Programme</th>
                                  <td>:</td>
                                  <td><b className="transferred-highlight transfer-txt">{studentdata.switched_major_name}</b></td>

                                </tr>
                              )}

                              <tr>
                                <th scope="row">Semester</th>
                                <td>:</td>
                                <td>{studentdata.currentsemester}</td>

                              </tr>

                              {/* <tr>
                                <th scope="row">Admission Year</th>
                                <td>:</td>
                                <td>{fullYear(studentdata.register_datetime)}</td>

                              </tr> */}

                              <tr>
                                <th scope="row">Admitted quota</th>
                                <td>:</td>
                                <td>{studentdata.admittedquota}</td>

                              </tr>

                              <tr>
                                <th scope="row">Reservation Category</th>
                                <td>:</td>
                                <td>{studentdata.reservation_name}</td>

                              </tr>


                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div className="card tranaction-card">
                <div className="card-header card-no-border">
                  <div className="d-flex justify-content-center align-items-center mb-4 ">
                    <h4 className="mb-0 text-dark text-center mobile">
                      Exam Details
                    </h4>
                  </div>

                  <div className="semester-tabs-wrapper">
                    {/* onChange={(e) => handleCoTabClick(e.target.value, parseInt(e.target.selectedOptions[0].getAttribute('data-sem-num')))} */}
                    <select className="form-select d-md-none mb-3" >
                      <option value="semester1" data-sem-num="1">Semester 1</option>
                      <option value="semester2" data-sem-num="2">Semester 2</option>
                      <option value="semester3" data-sem-num="3">Semester 3</option>
                      <option value="semester4" data-sem-num="4">Semester 4</option>
                      <option value="semester5" data-sem-num="5">Semester 5</option>
                      <option value="semester6" data-sem-num="6">Semester 6</option>
                      <option value="semester7" data-sem-num="7">Semester 7</option>
                      <option value="semester8" data-sem-num="8">Semester 8</option>
                    </select>

                    <div className="st-dash-sem-tab d-none d-md-block">
                      <div className="semester-tabs">
                        {[1, 2, 3, 4, 5, 6, 7, 8].map((semNum) => (
                          <button
                            key={semNum}
                            className={`semester-tab ${activecoTab === semNum ? 'active' : ''}`}
                            onClick={() => handleCoTabClick(semNum, semNum)}
                          >
                            Sem {semNum}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="accordion dark-accordion" id="outlineaccordion" ref={templateRef}>
                    {studentEXdata && studentResultdata ? (
                      Object.entries(studentEXdata).map(([examTitle, courses], index) => (
                        <div className="accordion-item accordion-wrapper" key={index}>
                          <div className="acodn-bot-line">
                            <h2 className="accordion-header" id={`heading${index}`}>
                              <button
                                className={`accordion-button txt-primary accordion-light-primary ${!deactiveTab.includes(examTitle) ? 'bg-lightblue' : ''
                                  }`}
                                type="button"
                                onClick={() => toggleTab(examTitle)}
                              >
                                {examTitle} &nbsp;&nbsp;
                                <i
                                  className={`${deactiveTab.includes(examTitle)
                                    ? 'bi bi-chevron-down svg-color'
                                    : 'bi bi-chevron-up svg-color'
                                    }`}
                                ></i>
                              </button>
                            </h2>
                          </div>
                          <div
                            className={`accordion-collapse collapse ${deactiveTab.includes(examTitle) ? '' : 'show'
                              }`}
                            id={`collapse${index}`}
                            aria-labelledby={`heading${index}`}
                            data-bs-parent="#outlineaccordion"
                          >
                            <div className="accordion-body">
                              <div className="table-responsive signal-table">
                                <table className="table ex-table1 table-bordered table-striped">
                                  <thead>
                                    <tr className="table-active" style={{ textAlign: 'center', verticalAlign: "middle" }}>
                                      <th scope="col" width="10%" rowSpan={2}>Sl. No.</th>
                                      <th scope="col" width="30%" rowSpan={2}>Course</th>
                                      <th scope="col" width="15%" colSpan={2}>Exam Attendance</th>
                                      <th scope="col" width="15%" rowSpan={2}>Paper Status</th>
                                      <th scope="col" width="15%" rowSpan={2}>Condonation Status</th>
                                      <th scope="col" width="15%" colSpan={2}>Result</th>
                                      <th scope="col" width="15%" rowSpan={2}>Grade</th>
                                      <th scope="col" width="15%" rowSpan={2}>Overall Result</th>
                                    </tr>
                                    <tr className="table-active">
                                      <td style={{ textAlign: 'center' }}>Theory</td>
                                      <td style={{ textAlign: 'center' }}>Practical</td>
                                      <td style={{ textAlign: 'center' }}>Theory</td>
                                      <td style={{ textAlign: 'center' }}>Practical</td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {courses.length > 0 && studentResultdata.length > 0 ? (
                                      courses.map((course, i) => {
                                        // Match the result_data by course_id
                                        // const resultData = studentResultdata.find(
                                        //   (result) => result.course_id === course.course_id
                                        // );
 const resultData = course.result_data;
                                        if (!resultData) {
                                          return (
                                            <tr key={course.course_id} className={i % 2 === 0 ? 'table-light' : 'table-secondary'} style={{ textAlign: 'center', verticalAlign: "middle" }}>
                                              <td>{i + 1}</td>
                                              <td>
                                                {course.course_code} - {course.course_name} - {course.discipline_name} - {course.college_course_type}
                                              </td>
                                              <td colSpan="8">Result data not available</td>
                                            </tr>
                                          );
                                        }

                                        return (
                                          <tr key={course.course_id} className={i % 2 === 0 ? 'table-light' : 'table-secondary'} style={{ textAlign: 'center', verticalAlign: "middle" }}>
                                            <td>{i + 1}</td>
                                            <td>
                                              {course.course_code} - {course.course_name} - {course.discipline_name} - {course.college_course_type}
                                            </td>
                                            <td>{resultData.theory_attendance === "" || resultData.theory_attendance === null ? '-' : resultData.theory_attendance}</td>
                                            <td>{resultData.pract_attendance === "" || resultData.pract_attendance === null ? '-' : resultData.pract_attendance}</td>
                                            <td>{course.paper_status === "" || course.paper_status === null ? '-' : course.paper_status}</td>
                                            <td>{course.concession_desc === "" || course.concession_desc === null ? '-' : course.concession_desc}</td>
                                            <td>{resultData.theory_result === "" || resultData.theory_result === null ? '-' : resultData.theory_result}</td>
                                            <td>{resultData.practical_result === "" || resultData.practical_result === null ? '-' : resultData.practical_result}</td>
                                            <td>{resultData.grade === "" || resultData.grade === null ? '-' : resultData.grade}</td>
                                            <td style={{ color: resultData.result === "Pass" ? "green" : "red", fontWeight: "bold" }}>{resultData.result === "" || resultData.result === null ? '-' : resultData.result}</td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td colSpan="10">No courses available for this exam</td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="txt-aln pdg11">No Data Found</div>
                    )}
                  </div>



                </div>


              </div>

              <div className="row ">

                <div className="col-xl-12 col-sm-12 col-xxl-12">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title mb-0 mobile">Qualifications</h4>

                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <div className="st-bx-bod ">
                          <table className="table st-table-hover align-middle mobile-table table-bordered">
                            <thead className="table-dark">
                              <tr>
                                <th scope="col" width="7%">Sl No.</th>
                                <th scope="col" width="10%">Examination</th>
                                <th scope="col" width="30%">Name of Board</th>
                                <th scope="col" width="15%">Stream/Group</th>
                                <th scope="col" width="20%">No. of chances availed</th>
                                <th scope="col" width="20%">Year of passing</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td data-label="Sl No.">1</td>
                                <td data-label="Examination">{studentdata.qualifying_exam}</td>
                                <td data-label="Name of Board">{studentdata.board_name}
                                  {/* <button
                                              className="btn btn-link text-decoration-none"
                                              onClick={toggleAccordion}
                                              style={{ fontSize: '1rem' }}
                                            >{isAccordionOpen ? <i className="bi bi-chevron-up"></i> : <i className="bi bi-chevron-down"></i>}
                                            </button> */}
                                </td>
                                <td data-label="Stream/Group">{studentdata.stream}</td>
                                <td data-label="No. of chances availed">{studentdata.no_of_chances}</td>
                                <td data-label="Year of passing">{studentdata.year_of_passing}</td>
                              </tr>
                              <tr>
                                <td>
                                </td>
                                <td>
                                </td>

                                <td colSpan={3}>
                                  <button
                                    className="btn btn-link text-decoration-none st-toggle-btn"
                                    onClick={toggleAccordion}
                                  > <span className="toggle-text">
                                      {isAccordionOpen ? "Hide Marks" : "View Marks"}
                                    </span>
                                    {isAccordionOpen ? (
                                      <i className="bi bi-chevron-up"></i>
                                    ) : (
                                      <i className="bi bi-chevron-down"></i>
                                    )}
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {isAccordionOpen && (

                            <div className="st-expanded-section m-15">
                              <h6 className="st-bx-h">Detailed Subject Scores</h6>
                              <div className="row">
                                {Array.isArray(markDetails) &&
                                  markDetails.length > 0 &&
                                  markDetails.map((mark, index) => (
                                    <React.Fragment key={index}>
                                      {mark?.first_language_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">

                                              {/* <h6 className="card-title text-primary">{mark.first_language_name}</h6> */}

                                              {mark.hasOwnProperty("first_language_name") ? (
                                                <h6 className="card-title text-primary">
                                                  {mark.first_language_name}{" "}
                                                  <span style={{ color: "#872e53" }}>(First Language)</span>
                                                </h6>
                                              ) : (
                                                <h6 className="card-title text-primary">
                                                  {mark.first_language_name}
                                                </h6>
                                              )}

                                              <p className="card-text" style={{ verticalAlign: 'middle' }}>
                                                <strong>Score:</strong> {mark.first_language_scoredmark}/
                                                {mark.first_language_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.second_language_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">

                                              {/* <h6 className="card-title text-primary">{mark.second_language_name}</h6> */}

                                              {mark.hasOwnProperty("second_language_name") ? (
                                                <h6 className="card-title text-primary">
                                                  {mark.second_language_name}{" "}
                                                  <span style={{ color: "#872e53" }}>(Second Language)</span>
                                                </h6>
                                              ) : (
                                                <h6 className="card-title text-primary">
                                                  {mark.second_language_name}
                                                </h6>
                                              )}

                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.second_language_scoredmark}/
                                                {mark.second_language_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.option1_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.option1_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.option1_scoredmark}/
                                                {mark.option1_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.option2_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.option2_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.option2_scoredmark}/
                                                {mark.option2_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.option3_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.option3_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.option3_scoredmark}/
                                                {mark.option3_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.option4_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.option4_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.option4_scoredmark}/
                                                {mark.option4_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.option5_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.option5_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.option5_scoredmark}/
                                                {mark.option5_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </React.Fragment>
                                  ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div >
          ) : (
            // <div className="row  m-b-20">

            //   <div className="col-xl-12 col-sm-12 col-xxl-12">
            //     <div className="card  d-flex justify-content-center align-items-center pdg11">



            //       <div class="card-body">
            //         <div class="table-responsive">

            //           <h5 className="card-title txt-aln mb-0">Student details not available</h5>



            //         </div>
            //       </div>

            //     </div>
            //   </div>
            // </div>
            <Loader />
          )}

        </div >
      </StudentTemplate >
    </>
  );
};

export default Home;